module.exports = __webpack_public_path__ + "/img/377fe0b416cc5ea36b57869c54f3a072.png";